const AuthBrand = () => {
  return (
    <div className="flex items-center gap-3 mb-6">
      <div className="w-12 h-12 rounded-2xl border border-border bg-surface shadow-sm flex items-center justify-center overflow-hidden flex-shrink-0 p-1.5">
        <img
          src="/favicon.jpg"
          alt="Surya Group"
          className="w-full h-full object-contain"
        />
      </div>
      <div>
        <p className="text-[15px] font-bold text-text_primary leading-none tracking-tight">
          SwiftBoard
        </p>
        <p className="text-[11px] mt-1.5 font-medium tracking-wide">
          <span className="text-text_muted">by </span>
          <span className="text-secondary font-bold">Surya</span>{" "}
          <span className="text-primary font-bold">Group</span>
        </p>
      </div>
    </div>
  );
};

export default AuthBrand;
